module.exports = __webpack_public_path__ + "img/3f_l_newtokyo.a1da5642.jpg";